import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import AiTeamCard from 'src/components/dashboard/ai-team-card';


const NOTIFY_ME_FORM_URL =
  'https://1f399.share.hsforms.com/2kdgSmarUQya7KZ154RE-Ew';

// Coming-soon agent: static, no backend. Watch Video stays disabled until the
// video player (HD-04) lands; Notify Me opens the HubSpot interest form.
function AiReceptionistCard(): React.ReactElement {
  const {t} = useLabelTranslation();

  return (
    <AiTeamCard
      state="coming_soon"
      title={t('AI_Receptionist', 'AI Receptionist')}
      badge={{text: t('Coming_Soon', 'Coming Soon'), fill: 'green'}}
      description={t('ai_receptionist_card_description', {
        defaultValue:
          'Instantly greet, qualify, and route every inbound candidate 24/7.',
      })}
      primaryAction={{
        label: t('Notify_Me', 'Notify Me'),
        iconRightName: 'envelope',
        onClick: () => window.open(NOTIFY_ME_FORM_URL, '_blank'),
      }}
      secondaryAction={{
        label: t('Watch_Video', 'Watch Video'),
        iconRightName: 'play',
        disabled: true,
      }}
      testId="ai-receptionist-card"
    />
  );
}

export default AiReceptionistCard;
